import React, {useRef, useEffect} from "react";

const AutoHeightTextarea = ({
                                className,
                                value,
                                onChange,
                                maxLength,
                                placeholder,
                                onKeyDown,
                                projectChatRef,
                                files,
                                chatActionsRef,
                                respondMessage
                            }) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;

            const allHeight = chatActionsRef?.current?.clientHeight

            if (allHeight) {
                projectChatRef.current.style.height = `calc(100% - ${allHeight}px)`
            }
        }
    }, [value, files,respondMessage]);

    return (
        <textarea
            className={className}
            maxLength={maxLength}
            ref={textareaRef}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown}
            style={{width: "100%", resize: "none"}}
        />
    );
};

export default AutoHeightTextarea;
